import { Injectable, Injector } from '@angular/core';
import { Store } from '@ngrx/store';
import * as ErrorActions from 'src/app/shared/error/store/actions/error.actions';
import { ErrorBase } from 'src/app/core/interfaces/error-base';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private store: Store | null = null;

  constructor(private injector: Injector) {}

  private getStore(): Store {
    if (!this.store) {
      this.store = this.injector.get(Store);
    }
    return this.store;
  }

  handleError(error: ErrorBase): void {
    const store = this.getStore();
    store.dispatch(ErrorActions.globalError({ error }));
  }
}
